import { useRef, useState, useEffect } from "react";
import { Eraser } from "lucide-react";

// Reusable finger/mouse signature pad -> PNG data URL via onChange.
export function SignaturePad({ onChange, height = 150, testid = "signature-pad" }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    const rect = c.getBoundingClientRect();
    c.width = rect.width * ratio;
    c.height = height * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#1c1c1e";
  }, [height]);

  const pos = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - rect.left, y: t.clientY - rect.top };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const { x, y } = pos(e); const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(x, y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const { x, y } = pos(e); const ctx = ref.current.getContext("2d"); ctx.lineTo(x, y); ctx.stroke(); if (empty) setEmpty(false); };
  const end = () => { if (!drawing.current) return; drawing.current = false; if (!empty && onChange) onChange(ref.current.toDataURL("image/png")); };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); onChange && onChange(null); };

  return (
    <div>
      <canvas ref={ref} data-testid={testid}
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        style={{ width: "100%", height, touchAction: "none", background: "#fff", borderRadius: 12, border: "1px solid var(--border)" }} />
      <div className="flex items-center justify-between mt-2">
        <span className="text-xs text-secondary">{empty ? "Sign in the box above" : "Signature captured"}</span>
        <button type="button" data-testid={`${testid}-clear`} onClick={clear} className="text-xs text-secondary flex items-center gap-1"><Eraser size={13} /> Clear</button>
      </div>
    </div>
  );
}
